<template>
  <div class="t-messageList" v-if="$route.query.sel && $route.query.sel !== 'all'">
    <div class="t-messageList__header">
      
        <template v-if="activeDialog.isGroup" >
          <div class="t-messageList__header-text">
            <h2>
              {{ activeDialog.name }}
            </h2>
            <span>{{ activeDialog.usersCount }} {{ usersCountText(activeDialog.usersCount) }}</span>
          </div>
          <div class="t-messageList__menu">
            <div class="t-messageList__menu-btn">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="t-messageList__menu-cloud">
              <router-link class="t-messageList__menu-header" :to="{name: 'user', params: {url: activeDialog.creator.url}}">
                <img v-if="activeDialog.creator.img !== ''" class="t-messageList__menu-creatorImg" :src="activeDialog.creator.img">
                <img v-else src="/img/default_img.png"  class="t-messageList__menu-creatorImg">
                <span>
                  {{ dialogText.dialogCreator }}
                </span> 
              </router-link>
              <div class="t-messageList__menu-actionsList">
                <template v-if="user.id == activeDialog.creator.id">
                  <div class="t-messageList__menu-action" @click="modalDialogType_dialogAddNewUser({id: activeDialog.id})"> {{ dialogText.dialogMenuAdd }} </div>
                  <div class="t-messageList__menu-action" @click="modalDialogType_dialogRename({id: activeDialog.id})"> {{ dialogText.dialogMenuReanme }} </div>
                  <div class="t-messageList__menu-action" @click="modalDialogType_dialogRemove({id: activeDialog.id, name: activeDialog.name, type: 'remove'})"> {{ dialogText.dialogMenuRemove }} </div>
                </template>
                <template v-else>
                  <div class="t-messageList__menu-action" @click="modalDialogType_dialogRemove({id: activeDialog.id, name: activeDialog.name, type: 'leave'})"> {{ dialogText.dialogMenuLeave }} </div>
                </template>
              </div>
            </div>
          </div>

        </template>
        <template v-else>
          <div class="t-messageList__header-text">
            <template v-if="!activeDialog.isAdmin">
              <h2>
                <router-link :to="{name: 'user', params: {url: activeDialog.url}}"> 
                  {{ activeDialog.name }}
                </router-link>
              </h2>
              <span v-if="activeDialog.online">{{ dialogText.online }}</span>
              <span v-else>{{ dialogText.offline }}</span>
            </template>
            <template v-else>
              <h2>
                {{ dialogText.supportName }}
              </h2>
            </template>
          </div>

        </template>

    </div>
    <div class="t-messageList__body">
      <v-bar v-if="!mobileState" wrapper="t-messageList__scroll">
        <div class="t-messageList__content">
          <div class="t-messageList__wrapper">
            <div class="t-message"
                  :class="{_right: item.my, '_system': item.type != 'message' }"
                  v-for="(item, index) in messageList.items"
                  :key="'message_' + index">
              <template v-if="item.type == 'message'">
                <router-link v-if="activeDialog.isGroup" class="t-message__img" :to="{name: 'user', params: {url: item.url!=undefined?item.url:'id'+item.authorId}}"> 
                  <img v-if="item.img !== ''" :src="item.img">
                  <img v-else-if="item.isAdmin" src="/img/default_img_support.png">
                  <img v-else src="/img/default_img.png">
                </router-link>
                <div class="t-message__content">
                  <div class="t-message__header">
                    <b>{{ item.user }}</b>
                    <span>{{ item.dateTime }}</span>
                  </div>
                  <div class="t-message__text" v-html="item.text" v-if="item.text !== ''"></div>
                  <a :href="item.file.url" download class="t-message__file" v-if="item.file">
                    <div class="img"></div>
                    <p><b>{{ item.file.name }}</b>{{ item.file.size }}</p>
                  </a>
                </div>
              </template>
              <template v-else-if="item.type == 'create'">
                <div class="t-message__content">
                  {{ dialogText.create1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.url!=undefined?item.url:'id'+item.authorId}}"> 
                    {{ item.user }}
                  </router-link>
                  {{ dialogText.create2 }} «{{ item.text }}»
                </div>
              </template>
              <template v-else-if="item.type == 'addUser'">
                <div class="t-message__content">
                  {{ dialogText.addUser1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.text.split(',')[0] }}"> 
                    {{ item.text.split(',')[1] }}
                  </router-link>
                  {{ dialogText.addUser2 }}
                </div>
              </template>
              <template v-else-if="item.type == 'removeUser'">
                <div class="t-message__content">
                  {{ dialogText.removeUser1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.text.split(',')[0] }}"> 
                    {{ item.text.split(',')[1] }}
                  </router-link>
                  {{ dialogText.removeUser2 }}
                </div>
              </template>
              <template v-else-if="item.type == 'renameChat'">
                <div class="t-message__content">
                  {{ dialogText.renameChat }}
                  «{{ item.text }}»
                </div>
              </template>
              <template v-else-if="item.type == 'leaveChat'">
                <div class="t-message__content">
                  {{ dialogText.leaveChat1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.url!=undefined?item.url:'id'+item.authorId}}"> 
                    {{ item.user }}
                  </router-link>
                  {{ dialogText.leaveChat2 }}
                </div>
              </template>

            </div>
          </div>
        </div>
      </v-bar>
      <div v-else class="t-messageList__content t-messageList__content_mobile">
        <div class="t-messageList__wrapper">
          <div class="t-message"
               :class="{_right: item.my, '_system': item.type != 'message'}"
               v-for="(item, index) in messageList.items"
               :key="'message_' + index">
              <template v-if="item.type == 'message'">
                <router-link v-if="activeDialog.isGroup" class="t-message__img" :to="{name: 'user', params: {url: item.url!=undefined?item.url:'id'+item.authorId}}"> 
                  <img v-if="item.img !== ''" :src="item.img">
                  <img v-else-if="item.isAdmin" src="/img/default_img_support.png">
                  <img v-else src="/img/default_img.png">
                </router-link>
                <div class="t-message__content">
                  <div class="t-message__header">
                    <b>{{ item.user }}</b>
                    <span>{{ item.dateTime }}</span>
                  </div>
                  <div class="t-message__text" v-html="item.text" v-if="item.text !== ''"></div>
                  <a :href="item.file.url" download class="t-message__file" v-if="item.file">
                    <div class="img"></div>
                    <p><b>{{ item.file.name }}</b>{{ item.file.size }}</p>
                  </a>
                </div>
              </template>
              <template v-else-if="item.type == 'create'">
                <div class="t-message__content">
                  {{ dialogText.create1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.url!=undefined?item.url:'id'+item.authorId}}"> 
                    {{ item.user }}
                  </router-link>
                  {{ dialogText.create2 }} «{{ item.text }}»
                </div>
              </template>
              <template v-else-if="item.type == 'addUser'">
                <div class="t-message__content">
                  {{ dialogText.addUser1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.text.split(',')[0] }}"> 
                    {{ item.text.split(',')[1] }}
                  </router-link>
                  {{ dialogText.addUser2 }}
                </div>
              </template>
              <template v-else-if="item.type == 'removeUser'">
                <div class="t-message__content">
                  {{ dialogText.removeUser1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.text.split(',')[0] }}"> 
                    {{ item.text.split(',')[1] }}
                  </router-link>
                  {{ dialogText.removeUser2 }}
                </div>
              </template>
              <template v-else-if="item.type == 'renameChat'">
                <div class="t-message__content">
                  {{ dialogText.renameChat }}
                  «{{ item.text }}»
                </div>
              </template>
              <template v-else-if="item.type == 'leaveChat'">
                <div class="t-message__content">
                  {{ dialogText.leaveChat1 }}
                  <router-link class="t-message__link" :to="{name: 'user', params: {url: item.url!=undefined?item.url:'id'+item.authorId}}"> 
                    {{ item.user }}
                  </router-link>
                  {{ dialogText.leaveChat2 }}
                </div>
              </template>
          </div>
        </div>
      </div>
    </div>
    <div class="t-messageList__footer">
      <form class="t-messageForm" @submit.prevent="Submit()" v-if="!activeDialog.blackList && !activeDialog.yourBlackList">
        <label class="t-messageForm__file">
          <input type="file" @change="LoadFile($event.target.files)">
          <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.15793 28.9537C0.185212 26.7976 -1.18066 22.0057 1.11299 18.2712L10.6203 2.79135C12.258 0.124943 15.9009 -0.792651 18.7374 0.746801C21.5759 2.28737 22.55 5.71076 20.9123 8.37717L12.5934 21.9221C11.6106 23.5223 9.42548 24.0727 7.72318 23.1488C6.02088 22.2249 5.43539 20.1708 6.41821 18.5706L13.5487 6.96066C13.8767 6.42661 14.604 6.24342 15.1721 6.55175C15.7402 6.86009 15.9351 7.54377 15.6071 8.07783L8.47661 19.6877C8.14979 20.2199 8.34554 20.9066 8.9116 21.2138C9.47766 21.521 10.2082 21.337 10.535 20.8049L18.8539 7.26001C19.8368 5.65977 19.2513 3.60568 17.549 2.68178C15.8467 1.75789 13.6616 2.30828 12.6787 3.90852L3.17139 19.3884C1.53256 22.0567 2.50987 25.4793 5.34634 27.0188C8.18488 28.5593 11.8246 27.6426 13.4634 24.9742L21.7823 11.4293C22.1103 10.8953 22.8376 10.7121 23.4057 11.0204C23.9739 11.3287 24.1687 12.0124 23.8407 12.5465L15.5218 26.0914C13.2281 29.8259 8.13064 31.1099 4.15793 28.9537Z" fill="#52A8F2"/>
          </svg>
        </label>
        <div class="t-messageForm__text">
          <div contenteditable="true" ref="text" @keydown="Enter($event)"></div>
          <button>
            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.92785 11.2886C7.20858 11.4365 7.42243 11.6898 7.52457 11.9954L8.61944 15.2711C8.72772 15.595 8.99956 15.6501 9.22708 15.3936L10.1392 14.3651C10.5421 13.9109 11.2076 13.8227 11.7104 14.1568L15.1073 16.4142C15.3894 16.6017 15.6853 16.4866 15.7713 16.1445L18.8254 3.9936C18.9099 3.65716 18.7266 3.4931 18.4136 3.62813L4.66968 9.55756C4.35769 9.69216 4.34547 9.92808 4.64909 10.088L6.92785 11.2886ZM0.662432 10.7994C-0.259238 10.3139 -0.208156 8.94906 0.747114 8.53693L20.3012 0.100869C21.2329 -0.301085 22.2116 0.561964 21.9599 1.5635L17.562 19.0605C17.354 19.8882 16.4132 20.263 15.7125 19.7974L11.7626 17.1725C11.48 16.9847 11.0647 17.0422 10.8428 17.2925L9.23433 19.106C8.60914 19.8109 7.47363 19.5711 7.17264 18.6706L5.56713 13.8673C5.45874 13.543 5.13091 13.1537 4.83076 12.9956L0.662432 10.7994Z" fill="#52A8F2"/>
            </svg>
          </button>
        </div>
        <div class="t-emoji" @mouseenter="open = true" @mouseleave="open = false">
          <div class="t-emojiOpen" >
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 30C6.72875 30 0 23.2712 0 15C0 6.72875 6.72875 0 15 0C23.2712 0 30 6.72875 30 15C30 23.2712 23.2712 30 15 30ZM15 2.5C8.1075 2.5 2.5 8.1075 2.5 15C2.5 21.8925 8.1075 27.5 15 27.5C21.8925 27.5 27.5 21.8925 27.5 15C27.5 8.1075 21.8925 2.5 15 2.5Z" fill="#52A8F2"/>
              <path d="M10.625 13.75C11.6605 13.75 12.5 12.9105 12.5 11.875C12.5 10.8395 11.6605 10 10.625 10C9.58947 10 8.75 10.8395 8.75 11.875C8.75 12.9105 9.58947 13.75 10.625 13.75Z" fill="#52A8F2"/>
              <path d="M19.375 13.75C20.4105 13.75 21.25 12.9105 21.25 11.875C21.25 10.8395 20.4105 10 19.375 10C18.3395 10 17.5 10.8395 17.5 11.875C17.5 12.9105 18.3395 13.75 19.375 13.75Z" fill="#52A8F2"/>
              <path d="M15.0004 23.7497C11.8942 23.7497 8.99294 22.0734 7.43044 19.3759C7.08419 18.7784 7.28794 18.0134 7.88544 17.6684C8.48419 17.3222 9.24794 17.5272 9.59419 18.1234C10.7104 20.0522 12.7829 21.2497 15.0004 21.2497C17.2192 21.2497 19.2917 20.0522 20.4067 18.1234C20.7517 17.5259 21.5129 17.3184 22.1142 17.6684C22.7117 18.0134 22.9167 18.7784 22.5692 19.3759C21.0092 22.0734 18.1079 23.7497 15.0004 23.7497Z" fill="#52A8F2"/>
            </svg>
          </div>
          <transition name="fade">
            <div class="t-emojiList" v-if="open">
              <div class="t-emojiItem" v-for="(item, index) in emoji" :key="'emoji_' + index" @click.prevent="AddEmoji(item)">
                <img :src="item">
              </div>
            </div>
          </transition>
        </div>
      </form>
      <p class="t-message-black-list" v-if="activeDialog.blackList && !activeDialog.yourBlackList">
        {{ dialogText.blackList }}
      </p>
      <p class="t-message-black-list" v-if="activeDialog.yourBlackList">
        {{ dialogText.yourBlackList }} <router-link :to="{name: 'black_list'}">{{ dialogText.yourBlackList2 }}</router-link>
      </p>
    </div>
  </div>
  <div class="t-messageList_empty" v-else><h2>{{ dialogText.hint }}</h2></div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import VBar from 'v-bar'

    export  default {
        components: {
            VBar
        },
        data(){
            return{
                open: false
            }
        },
        computed: {
            ...mapGetters('staticText', ['dialogText']),
            ...mapGetters('dialog', ['user', 'messageList']),
            ...mapGetters('handbook', ['emoji']),
            ...mapGetters(['mobileState']),
            id(){
                return this.$route.query.sel;
            },
            activeDialog(){
                return this.$store.getters['dialog/activeDialog'](this.id);
            },
        },
        methods: {
            ...mapActions('msg', ['showMsg']),
            ...mapActions('dialog', ['LoadMessageList', 'LoadDialogList']),
            ...mapActions('modal', ['modalDialogType_dialogAddNewUser', 'modalDialogType_dialogRename', 'modalDialogType_dialogRemove', 'modalDialogType_dialogLeave']),
            Submit(){
                let formData = new FormData();

                let text = this.$refs.text.innerHTML.replace(/(<script>|<\/script>)/g, "");
                text = text.replace(/(&lt;script&gt;|&lt;\/script&gt;)/g, "");
                text = text.replace(/&nbsp;/g, " ").replace(/\s\s+/g, "").replace(/^\s*/,'').replace(/\s*$/,'');
                let testText = text.replace(/(<div>|<\/div>)/g, '').replace(/(<br>)/g, '');

                if (testText != '') {
                    formData.append('text' , text);
                    this.$http.post('dialog/' + this.$route.query.sel, formData)
                        .then(response => response.json())
                        .then(data => {
                            if (data.success){
                                this.$refs.text.innerHTML = '';
                                this.LoadMessageList(this.$route.query.sel).then(() => {
                                    let height = document.querySelector('.t-messageList__wrapper').clientHeight;
                                    let elem = !this.mobileState ?
                                        document.querySelector('.t-messageList__scroll').querySelector('.bar--wrapper') :
                                        document.querySelector('.t-messageList__body');
                                    elem.scrollTop = height;
                                });
                            } else{
                                this.showMsg(data.errors.text[0])
                            }
                        })
                        .catch(error => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        });
                } else {
                    this.$refs.text.innerHTML = '';
                }

            },
            LoadFile(event){
                let formData = new FormData();
                formData.append('file' , event[0]);

                this.$http.post('dialog/' + this.$route.query.sel, formData)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success){
                            this.LoadMessageList(this.$route.query.sel)
                        } else{
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            AddEmoji(item){
                let textBox = this.$refs.text;
                let child = textBox.querySelectorAll('div');

                let newImg = document.createElement('img');
                newImg.src = item;

                let parent = textBox;
                let position = this.getCaretPosition(textBox);

                if(position === null){
                    for(let i = 0; i < child.length; i++){
                        position = this.getCaretPosition(child[i]);

                        if(position !== null){
                            parent = child[i];
                            break;
                        }
                    }
                }
                if(position === null){
                    if(child.length){
                        parent = child[child.length - 1];
                    } else{
                        parent = textBox;
                    }

                    position = parent.innerHTML.length
                }

                this.insertAfter(parent, item, position);
                this.open = false;
            },
            getCaretPosition(editableDiv) {
                let caretPos = null,
                    sel, range;
                if (window.getSelection) {
                    sel = window.getSelection();
                    if (sel.rangeCount) {
                        range = sel.getRangeAt(0);
                        if (range.commonAncestorContainer.parentNode === editableDiv) {
                            caretPos = range.endOffset;
                        }
                    }
                } else if (document.selection && document.selection.createRange) {
                    range = document.selection.createRange();
                    if (range.parentElement() === editableDiv) {
                        let tempEl = document.createElement("span");
                        editableDiv.insertBefore(tempEl, editableDiv.firstChild);
                        let tempRange = range.duplicate();
                        tempRange.moveToElementText(tempEl);
                        tempRange.setEndPoint("EndToEnd", range);
                        caretPos = tempRange.text.length;
                    }
                }

                return caretPos;
            },
            insertAfter(parent, src, index) {
                let text = '';

                for(let i = 0; i < index; i++){
                    text += parent.innerHTML[i];
                }

                text += '<img src="' + src + '">';

                for(let i = index; i < parent.innerHTML.length; i++){
                    text += parent.innerHTML[i];
                }

                parent.innerHTML = text;
            },
            Enter(e){
                if (e.ctrlKey && e.keyCode == 13) {
                    this.Submit();
                }
            },
            usersCountText(count){
              let arr = ['участник', 'участника', 'участников' ]
              if (count == 1)
                return arr[0]
              else if ( count < 5)
                return arr[1]
              else
                return arr[2]

            }
        },
        updated(){
            if(this.$route.query.sel && this.$route.query.sel !== 'all'){
                let height = document.querySelector('.t-messageList__wrapper').clientHeight;
                let elem = !this.mobileState ?
                    document.querySelector('.t-messageList__scroll').querySelector('.bar--wrapper') :
                    document.querySelector('.t-messageList__content_mobile');
                elem.scrollTop = height;
            }
        },
        mounted(){
            if(this.$route.query.sel && this.$route.query.sel !== 'all'){
                let height = document.querySelector('.t-messageList__wrapper').clientHeight;
                let elem = !this.mobileState ?
                    document.querySelector('.t-messageList__scroll').querySelector('.bar--wrapper') :
                    document.querySelector('.t-messageList__content_mobile');
                elem.scrollTop = height;
            }
        }
    }
</script>

<style lang="sass">

@keyframes a-show
  from 
    display: block
    opacity: 0
  to
    display: block
    opacity: 1


.t-messageList
  display: table
  max-width: 620px
  width: 100%
  @extend %substrate
  padding: 14px 20px 24px 24px
  margin-right: 24px
  height: calc(100vh - 200px)
  &_empty
    padding-left: 76px
    display: flex
    align-items: center
    max-width: 487px
    align-self: stretch
    h2
      font-size: 36px
      color: $blue
  &__header
    height: 50px
    margin-right: 24px
    display: flex
    flex-direction: row
    justify-content: center
    padding-bottom: 8px
    border-bottom: 1px solid $input
    flex: none
    position: relative
    &-text
      display: flex
      flex-direction: column
      align-items: center
      width: 100% 
      h2
        font-size: 18px
        color: $blue
        a
          color: $blue
      span
        font-size: 12px
      @media(max-width: 769px)
        align-items: flex-start
  &__menu
    // justify-self: flex-end
    margin-left: auto
    margin-right: - 10px
    position: absolute
    right: 0
    top: 0
    &:hover
      .t-messageList__menu-cloud
        display: block
        animation: a-show forwards .3s
    @media(max-width: 769px)
      position: relative
      
    &-btn
      padding: 10px
      width: 40px
      height: 40px
      display: flex
      justify-content: space-between
      align-items: center
      cursor: pointer
      span
        background: $blue
        border-radius: 1px
        height: 4px
        width: 4px
    &-cloud
      @extend %substrate
      box-shadow: $shadow
      display: none
      position: absolute
      right: -10px
      top: calc(100% - 20px)
      padding: 8px
      z-index: 10
      animation: a-show backwards .3s 
    &-header
      display: flex
      flex-direction: row
      justify-content: flex-end
      align-items: center
      margin: 16px
      font-size: 12px
    &-creatorImg
      width: 32px
      height: 32px
      border-radius: 1000px
      margin-right: 8px
    &-actionsList
      width: 208px
      border-top: 1px solid $input
      padding: 16px
    &-action
      color: $black
      font-weight: 500
      text-align: right
      cursor: pointer
      &:not(:last-child)
        margin-bottom: 8px
      &:last-child
        margin-top: 16px

  &__body
    display: table-row
    height: 100%
  &__scroll
    margin: 7px 0
    height: 100%
    .bar--vertical
      width: 1px
      background: $disabled
    .bar--vertical-internal
      opacity: 1
      background: $blue
  &__content
    &_mobile
      height: calc(100vh - 200px)
      overflow-y: auto
  &__wrapper
    padding-right: 24px
    display: flex
    flex-direction: column
    align-items: flex-start
  &__footer
    display: table-row

.t-message
  margin: 0 0 12px
  line-height: 1.2
  display: flex
  justify-content: space-between
  max-width: 412px
  &__img
    display: block
    width: 50px
    height: 50px
    border-radius: 1000px
    overflow: hidden
    margin-right: 8px
    img
      width: 100%
      height: 100%
      object-fit: cover
  &__content
    max-width: 354px
  &__header
    display: flex
    margin-bottom: 4px
    padding: 0 12px
    b
      font-size: 14px
      margin-right: 8px
    span
      font-size: 12px
  &__text
    padding: 8px 12px
    background: $promo
    border-radius: 8px
    font-size: 14px
    line-height: 20px
    white-space: pre-line
    word-break: break-word
    font-family: 'rubik', Arial, sans-serif
  &__file
    padding: 14px
    background: $promo
    border-radius: 8px
    display: flex
    align-items: center
    .img
      margin-right: 13px
      width: 36px
      height: 50px
      background: url('/img/doc_big.png') no-repeat center
      background-size: contain
    p
      font-size: 14px
      b
        font-weight: normal
        display: block
        margin-bottom: 4px
        color: $blue
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
  &._right
    align-self: flex-end
    .t-message__text, .t-message__file
      background: $input
    .t-message__img
      order: 1
      margin-right: 0
      margin-left: 8px
  &._system
    max-width: 100%
    width: 100%
    .t-message__content
      max-width: 100%
      width: 100%
      text-align: center
      font-size: 12px
      line-height: 16px
    .t-message__link
      border-bottom: 1px solid transparent
      transition: border-color .3s
      &:hover
        border-color: $black

.t-messageForm
  display: flex
  align-items: flex-end
  position: relative
  padding-top: 24px
  margin-right: 24px
  border-top: 1px solid $input
  background: #ffffff
  &__file
    margin-bottom: 5px
    cursor: pointer
    input
      position: absolute
      left: -99999px
    svg
      display: block
  &__text
    position: relative
    flex: 1
    margin: 0 24px
    > div
      border-radius: 8px
      background: $input
      padding: 11px 40px 10px 16px
      line-height: 1.2
      outline: none
      min-height: 40px
      // max-height: 92px
      max-height: 30vh
      max-width: 450px
      overflow-y: auto
      overflow-x: hidden
      resize: none
      -ms-overflow-style: none
      overflow: -moz-scrollbars-none
      &::-webkit-scrollbar
        width: 0
    img
      width: 19px
    button
      position: absolute
      right: 12px
      bottom: 9px
      background: transparent
      border: none
      outline: none
      cursor: pointer

.t-emojiOpen
  margin-bottom: 5px
  cursor: pointer
  svg
    display: block

.t-emojiList
  position: absolute
  right: 0
  bottom: 48px
  display: flex
  align-items: center
  justify-content: flex-start
  flex-wrap: wrap
  padding: 8px
  @extend %substrate
  width: 224px
.t-emojiItem
  margin: 6px
  cursor: pointer

.t-message-black-list
  font-weight: bold
  text-align: center
  padding-top: 24px
  border-top: 1px solid $input
  margin-top: 7px
  a
    color: $blue

@media(max-width: 769px)
  .t-messageList
    padding: 14px 16px 16px
    margin: 0
    width: 100%
    height: calc(100vh - 140px)
    &__header
      margin-right: 0
      align-items: flex-start
    &__body
      overflow-y: auto
    &__wrapper
      padding: 0
    &__footer
      margin: 0

  .t-message
    &__content
      max-width: 260px
    &__img
      width: 32px
      height: 32px
  .t-messageForm
    margin: 0
    position: relative
    &__file
      position: absolute
      z-index: 2
      right: 84px
      top: 34px
      svg
        width: 17px
        height: 20px
    &__text
      margin: 0
      z-index: 1
      padding-right: 40px

  .t-emoji
    position: absolute
    top: 34px
    right: 50px
    z-index: 2
  .t-emojiOpen
    svg
      width: 20px
      height: 20px
</style>


// WEBPACK FOOTER //
// src/vue_components/Dialog/MessageList.vue